@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@wide-desktop: ~'only screen and (min-width: 1440px)';
@medium-desktop: ~'only screen and (min-width: 1250px) and (max-width: 1439px)';
@small-desktop: ~'only screen and (min-width: 1025px) and (max-width: 1249px)';
@tablet: ~'only screen and (min-width: 720px) and (max-width: 1024px)';

.verification-notification {
  position: absolute;
  bottom: 15%;
  background: @scan-page--verify-notifier--background-color;
  margin: 0 15px;
  color: @scan-page--verify-notifier--text-color;
  border-radius: 4px;
  display: flex;
  padding-left: 40px;
  justify-content: space-between;
  align-items: center;

  @media @tablet {
    width: 55%;
  }

  @media @small-desktop {
    width: 60%;
  }

  @media @medium-desktop {
    width: 65%;
  }

  @media @wide-desktop {
    width: 70%;
  }

  .verification-text {
    display: flex;
    flex-direction: column;
    padding: 20px;

    > span {
      font-size: 14px;
      margin-bottom: 5px;
    }

    .item-name {
      font-size: 24px;
      font-weight: @bold;
    }
  }

  svg {
    height: 75px;
    width: 75px;
    fill: @scan-page--verify-notifier--icon-color;
    cursor: pointer;
    transform: scale(0.5);
  }
}
